export const logar = "Logar"

export const deslogar = "Deslogar"